<template>
  <b-modal
      ref="add-applicant-modal"
      id="add-applicant-modal"
      size="xl"
      title="Добавление кандидата в ручную"
      modal-class="unit_modal"
      scrollable
      :ok-title="trans('common.Add_txt')"
      :cancel-title="trans('common.Cancel_txt')"
      @ok.prevent="save"
      @show="handleShow"
      :ok-disabled="loader"
      centered
  >
    <loader v-if="loader"></loader>
    <div v-if="!loader && edit != null">
      <div class="form_fields_block">
        <b-form-group label="В какую вакансию добавляем кандидата?" :invalid-feedback="validations.vacancy_id" label-for="vacancy_id">
          <b-form-select v-model="edit.vacancy_id" id="vacancy_id" :state="isState(validations.vacancy_id)" :options="this.get_options(vacancies)"></b-form-select>
        </b-form-group>
        <b-form-group label="Статус кандидата" :invalid-feedback="validations.status_id" label-for="status_id">
          <b-form-select v-model="edit.status_id" :options="this.get_options(statuses)" id="status_id"  :state="isState(validations.status_id)"></b-form-select>
        </b-form-group>
      </div>
      <div class="form_fields_block">
        <div>
          <b-form-group id="last_name-label" :label="trans('labels.last_name')" label-for="last_name">
            <b-form-input id="last_name" v-model="edit.last_name" :placeholder="trans('labels.last_name')"></b-form-input>
          </b-form-group>
        </div>
        <div>
          <b-form-group id="first_name-label" :label="trans('labels.first_name')" label-for="first_name" :invalid-feedback="validations.first_name">
            <b-form-input id="first_name" v-model="edit.first_name" :state="isState(validations.first_name)" :placeholder="trans('labels.first_name')"></b-form-input>
          </b-form-group>
        </div>
        <div>
          <b-form-group id="sur_name-label" :label="trans('labels.sur_name')" label-for="sur_name">
            <b-form-input id="sur_name" v-model="edit.sur_name" :placeholder="trans('labels.sur_name')"></b-form-input>
          </b-form-group>
        </div>
        <div>
          <b-form-group id="age-label" :label="trans('labels.age')" label-for="age" :invalid-feedback="validations.age">
            <b-form-input id="age" v-model="edit.age" :state="isState(validations.age)" :placeholder="trans('labels.age')"></b-form-input>
          </b-form-group>
        </div>
        <div>
          <b-form-group id="gender-label" :label="trans('labels.gender')" label-for="gender">
            <b-form-select id="gender" v-model="edit.gender_raw"
                           :options="[{'value':'f','text':this.trans('common.female')},{'value':'m','text':this.trans('common.male')}]"></b-form-select>
          </b-form-group>
        </div>
        <div>
          <b-form-group id="country-label" :label="trans('labels.country')" label-for="country">
            <b-form-input id="country" v-model="edit.country" :placeholder="trans('labels.country')"></b-form-input>
          </b-form-group>
        </div>
        <div>
          <b-form-group id="city-label" :label="trans('labels.city')" label-for="city">
            <b-form-input id="city" v-model="edit.city" :placeholder="trans('labels.city')"></b-form-input>
          </b-form-group>
        </div>
        <div>
          <b-form-group id="phone-label" :label="trans('labels.phone')" label-for="phone" :invalid-feedback="validations.phone" class="m_b-0">
            <b-form-input
                id="phone"
                v-model="edit.phone"
                :state="isState(validations.phone)"
                :placeholder="trans('labels.phone')">
              >
            </b-form-input>
          </b-form-group>
        </div>
        <div>
          <b-form-group id="email-label" label="Email" label-for="email" :invalid-feedback="validations.email" class="m_b-0">
            <b-form-input id="email" placeholder="E-mail" v-model="edit.email" :state="isState(validations.email)"></b-form-input>
          </b-form-group>
        </div>
        <div>
          <b-form-group id="phone-label" label="Whatsapp" label-for="phone" :invalid-feedback="validations.whatsapp" class="m_b-0">
            <b-form-input id="phone" v-model="edit.whatsapp" :placeholder="trans('labels.number_whatsapp_placeholder')" :state="isState(validations.whatsapp)"></b-form-input>
          </b-form-group>
        </div>
        <div>
          <b-form-group id="phone-label" label="Telegram" label-for="phone">
            <b-form-input id="phone" :placeholder="trans('labels.username_telegram_placeholder')" v-model="edit.telegram"></b-form-input>
          </b-form-group>
        </div>
        <div>
          <b-form-group id="phone-country-code-label" label="Телефонный код страны" label-for="phone-country-code" class="mb-0">
            <b-form-select id="phone-country-code" v-model="edit.phone_country_code" :options="phoneRegionOptions"></b-form-select>
          </b-form-group>
        </div>
      </div>
    </div>
  </b-modal>
</template>
<script>
import loader from "@/components/loader-inline";

export default {
  components: {loader},
  props: [],
  name: 'add-applicant-modal',
  computed: {
    phoneRegionOptions() {
      return this.countries.map(({region_code, title}) => ({text: title, value: region_code}))
    },
  },

  data() {
    return {
      countries: [],
      vacancies: [],
      projects: [],
      statuses: [],
      edit: null,
      loader: false,
      validations: {
        status_id: null,
        vacancy_id: null,
        city: null,
        last_name: null,
        first_name: null,
        phone: null,
        whatsapp: null,
        email: null,
        age: null
      }
    }
  },
  async mounted() {

  },
  watch: {
    'edit.phone': function () {
      this.validations.phone !== null && this.phoneValid();
    },
    'edit.vacancy_id': function (vacancy_id) {
      if(vacancy_id) {
        this.statuses = this.vacancies.find(({id}) => vacancy_id === id).statuses
        console.log('statuses', this.statuses)
        this.validations.vacancy_id !== null && this.vacancy_idValid()
      }
      this.edit.status_id = null;
    },
    'edit.status_id': function () {
      this.validations.status_id !== null && this.status_idValid()
    },
    'edit.whatsapp': function () {
      this.validations.whatsapp !== null && this.whatsappValid();
    },
    'edit.email': function () {
      this.validations.email !== null && this.emailValid();
    },
    'edit.age': function () {
      this.validations.age !== null && this.ageValid();
    },
    'edit.first_name': function () {
      this.validations.first_name !== null && this.first_nameValid();
    },
  },
  methods:
      {
        fetchVacancies() {
          return this.$http.get('/api/vacancies', {params:{relations: ['statuses']}}).then(({data}) => {
            this.vacancies = data;
          })
        },
        fetchCountries() {
          return this.$http.get('/api/countries').then(({data}) => {
            this.countries = data;
          })
        },
        isState(val) {
          if(val === null) return val;
          if(val?.length) return false;
          if(!val.length) return null;
          return null
        },
        first_nameValid() {
          this.validations.first_name = '';
          if(!this.edit.first_name?.trim().length) this.validations.first_name = this.trans('validation.enter_name');
          return !this.validations.first_name.length
        },
        status_idValid() {
          this.validations.status_id = '';
          if(!this.edit.status_id) this.validations.status_id = 'Выберите статус'
          return !this.validations.status_id.length
        },
        vacancy_idValid() {
          this.validations.vacancy_id = '';
          if(!this.edit.vacancy_id) this.validations.vacancy_id = 'Выберите вакансию'
          return !this.validations.vacancy_id.length
        },
        ageValid() {
          this.validations.age = '';
          if(!this.edit.age) return true;
          else if (!/^\+?\d+$/.test(this.edit.age)) this.validations.age = this.trans('validation.age_only_number');
          else if (this.edit.age > 100 || this.edit.age < 14) this.validations.age = this.trans('validation.age_more_or_small');
          return !this.validations.age.length
        },
        phoneValid() {
          this.validations.phone = '';
          if(!this.edit.phone?.trim().length && this.edit.email?.trim().length) return true
          else if(!this.edit.phone?.trim().length) this.validations.phone = this.trans('validation.enter_phone');
          else if (this.edit.phone?.trim().length <= 8) this.validations.phone = this.trans('validation.phone_not_smaller_8');
          else if (!/^\+?[\d()\s-]+$/gi.test(this.edit.phone)) this.validations.phone = this.trans('validation.phone_only_number');
          return !this.validations.phone.length
        },
        emailValid() {
          this.validations.email = '';
          if(!this.edit.email?.trim().length && this.edit.phone?.trim().length) return true
          else if(!this.edit.email?.trim().length) this.validations.email = this.trans('validation.enter_email');
          else if (!/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.edit.email)) {
            this.validations.email = this.trans('validation.incorrect_email');
          }
          return !this.validations.email.length
        },
        whatsappValid() {
          this.validations.whatsapp = '';
          if (this.edit.whatsapp?.trim().length && this.edit.whatsapp?.trim().length <= 8) this.validations.whatsapp = this.trans('validation.phone_not_smaller_8');
          if (this.edit.whatsapp?.trim().length && !/^\+?[\d()\s-]+$/gi.test(this.edit.whatsapp)) this.validations.whatsapp = this.trans('validation.phone_only_number');
          return !this.validations.whatsapp.length
        },
        checkValidation() {
          return Object.keys(this.edit).map((f) => {
            if (this[`${f}Valid`]) return this[`${f}Valid`]();
            return true;
          }).every(t => t)
        },
        save() {
          if (this.checkValidation()) {
            this.loader = true;
            this.$http.post('/api/applicants/update', {...this.edit, gender: this.edit.gender_raw});
            setTimeout(function () {
              this.$root.$emit('bv::hide::modal', 'add-applicant-modal');
              this.loader = false;
            }.bind(this), 1000);
          }
        },
        resetValidations() {
          Object.keys(this.validations).forEach(k => this.validations[k] = null);
        },
        clear_applicant() {
          this.resetValidations()
          return {
            first_name: '',
            sur_name: '',
            last_name: '',
            email: '',
            phone: '',
            country: '',
            city: '',
            age: '',
            gender_raw: null,
            status_id: null,
            whatsapp: '',
            telegram: '',
            vacancy_id: null,
            source: '',
            phone_country_code: 'RU',
            came_from: 5
          }
        },
        async handleShow() {
          this.loader = true
          await this.fetchCountries()
          await this.fetchVacancies()
          this.resetValidations()
          this.edit = this.clear_applicant();
          this.loader = false
        }
      },
}
</script>

<style>
#add-applicant-modal .m_b-0 {margin-bottom: 0}
#add-applicant-modal .form_fields_block {display: grid; grid-template-columns: repeat(4, 1fr); grid-gap: 0 16px;}
@media (max-width: 992px) {
  #add-applicant-modal .form_fields_block {grid-template-columns: 1fr; grid-gap: 0 0;}
  #add-applicant-modal .m_b-0 {margin-bottom: 16px !important;}
}
</style>
